export function AINotice() {
  return (
    <footer style={{ fontSize: 12, marginTop: 4 }}>
      <div>Results provided by AI and may be incorrect.</div>
    </footer>
  );
}
